<template>
	<div>
		<o-section
			v-if="timeTicketWeek.attachments.length"
			title="Documents attachés">
			<div class="time-ticket-attachments">
				<o-card
					v-for="file in timeTicketWeek.attachments"
					:key="file.id"
					:selected="setup.fileIsSelected(file)"
					class="time-ticket-attachment-card">
					<template #poster>
						<img
							class="time-ticket-attachment-card__poster"
							:src="`/app/${setup.self.readableUserType?.toLowerCase()}/timeticketattachment/${file.id}/preview`"
							@error="$event => setup.addMissingPreview($event)">
					</template>

					<div>
						<div class="time-ticket-attachment-card__title">
							{{ file.title }}
						</div>
						<div class="time-ticket-attachment-card__actions">
							<o-icon
								v-tooltip="`Visualiser`"
								font-icon="icon-interface-edit-view"
								ripple="info"
								@click="setup.viewFiles([file])"/>
							<o-icon
								v-tooltip="`Télécharger`"
								font-icon="icon-interface-download-button-2"
								ripple="info"
								@click="setup.downloadFilesAsync([file])"/>
							<o-icon
								v-tooltip="`Sélectionner`"
								font-icon="icon-interface-validation-check"
								ripple="info"
								:class="{ 'text--info': setup.fileIsSelected(file) }"
								@click="setup.selectFile(file)"/>
							<o-icon
								v-if="setup.self.isTempWorker()"
								v-tooltip="`Supprimer`"
								font-icon="icon-interface-delete-bin-2"
								ripple="danger"
								@click="setup.deleteFileAsync(file)"/>
						</div>
					</div>
				</o-card>
			</div>
		</o-section>

		<o-section
			v-if="setup.selectedFilesIds.length"
			align="center">
			<o-button
				outline
				prefix-font-icon="icon-interface-block"
				@click="setup.selectedFiles = []">
				Annuler la sélection
			</o-button>
			<o-button
				color="info"
				outline
				prefix-font-icon="icon-interface-download-button-2"
				@click="setup.downloadFilesAsync(setup.selectedFiles)">
				Télécharger les fichiers
			</o-button>
		</o-section>

		<o-section
			v-if="setup.self.isTempWorker()"
			title="Charger un nouveau document">
			<o-upload
				:ref="setup._upload"
				v-model="setup.filesUpload"/>
			<o-input
				:ref="setup._fileTitle"
				v-model.trim="setup.fileTitle"
				required
				label="Titre du document"/>
			<o-section
				v-if="setup.fileTitle && setup.filesUpload.length"
				align="right">
				<o-button
					color="success"
					outline
					@click="setup.uploadNewFileAsync()">
					Ajouter le document
				</o-button>
			</o-section>
		</o-section>
	</div>
</template>

<script setup lang="ts">
import TimeTicketAttachmentAsideSetupService from '@/setup/time-ticket/TimeTicketAttachmentAsideSetupService';
import { inject } from 'vue';
const _aside = inject<OrionAside>('_aside');
const props = defineProps(TimeTicketAttachmentAsideSetupService.props);
const setup = new TimeTicketAttachmentAsideSetupService(props, _aside);
</script>


<style scoped lang="less">
@import '@/styles/variables';
@import '@/styles/mixins';
.time-ticket-attachments {
  display: flex;
  align-items: stretch;
  margin: 0 -0.6rem;

  @media @phone {
    overflow: auto;
    margin-right: 0;
  }

  @media @tablet {
    flex-wrap: wrap;
  }

  .time-ticket-attachment-card {
    flex: 0 0 calc(33% - 1.3rem);
    width: calc(33% - 1.3rem);
    margin: 0.6rem;

    @media @phone {
      flex: 0 0 13.8rem;
      max-width: 13.8rem;
    }

    &__poster {
      height: 9.4rem;
    }

    &__title {
      .ellipsis();
      text-align: center;
      font-weight: 600;
      color: var(--grey-darker);
    }

    &__actions {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.9rem;
      font-size: 1rem;

      > .orion-icon {
        margin: 0.3rem 0.6rem 0;
      }
    }
  }
}
</style>
